export default "__VITE_ASSET__zScjVKN9__"